export default __webpack_public_path__ + "static/media/service-thumb-asphalt-court.3d1d61f5.jpg";